import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import "./course.survey.cmp.scss";

const RATING_VALUES = [1, 2, 3, 4, 5];

const CourseSurveyCmp = ({
  courseId,
  innerRef,
  afterSubmitting,
  submitFeedback,
}) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [permissionToPublish, setPermissionToPublish] = useState(false);
  const [ratingError, setRatingError] = useState("");
  const [feedbackError, setFeedbackError] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();

    const feedbackText = feedback.trim();
    if (!rating) {
      setRatingError("Please select a star rating.");
      return;
    }

    if (!feedbackText) {
      setFeedbackError("Please add your feedback before submitting.");
      return;
    }

    setRatingError("");
    setFeedbackError("");
    await submitFeedback({
      courseId,
      rating,
      feedback: feedbackText,
      permissionToPublish,
    });

    if (afterSubmitting) afterSubmitting();
  };

  return (
    <form onSubmit={onSubmit} ref={innerRef} className="course-survey">
      <div className="course-survey__intro">
        <p>
          We would love to hear your feedback before you continue. Your comments
          help us improve the course experience for coaches.
        </p>
      </div>

      <div className="course-survey__rating-label">Your rating</div>
      <div
        className="course-survey__rating"
        role="radiogroup"
        aria-label="Course rating"
      >
        {RATING_VALUES.map((value) => (
          <button
            key={value}
            type="button"
            className={`course-survey__star ${
              value <= rating ? "course-survey__star--active" : ""
            }`}
            aria-label={`${value} star${value === 1 ? "" : "s"}`}
            aria-checked={rating === value}
            role="radio"
            onClick={() => {
              setRating(value);
              if (ratingError) setRatingError("");
            }}
          >
            <FontAwesomeIcon icon={faStar as Icon} />
          </button>
        ))}
      </div>
      {ratingError ? (
        <div className="course-survey__error">{ratingError}</div>
      ) : null}

      <label className="course-survey__label" htmlFor="course-feedback">
        Your feedback
      </label>
      <textarea
        id="course-feedback"
        value={feedback}
        onChange={(event) => {
          setFeedback(event.target.value);
          if (feedbackError) setFeedbackError("");
        }}
        placeholder="Tell us what worked well, what could be clearer, or anything else you want us to know."
        required
        rows={6}
      />
      {feedbackError ? (
        <div className="course-survey__error">{feedbackError}</div>
      ) : null}

      <label className="course-survey__permission">
        <input
          type="checkbox"
          checked={permissionToPublish}
          onChange={(event) => setPermissionToPublish(event.target.checked)}
        />
        <span>
          I give CoachSafely permission to publish my feedback on the website.
        </span>
      </label>
    </form>
  );
};

export default CourseSurveyCmp;
